import { useQuery } from "@apollo/client"
import { ReportData, ReportOptions, ReportType } from ".."
import { GetGroupReportQuery, GET_GROUP_REPORT } from "../graphql/queries/getGroupReport"

export const useGroupReport = (options: ReportType<ReportOptions, "group">) => {
  const { data, loading } = useQuery<GetGroupReportQuery>(GET_GROUP_REPORT, {
    variables: {
      id: options.groupId,
    },
  })

  return {
    data:
      data &&
      ({
        type: "group",
        group: data?.group,
      } as ReportType<ReportData, "group">),
    loading,
  }
}
